<template>
  <div style="padding:20px;">
    <el-row>
      <el-col :span="24">
        <el-button
            style="padding: 0; margin: 20px"
            type="text"
            icon="el-icon-back"
            @click="backPrePage()"
        >
          返回
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-form ref="form" :model="form" label-width="150px" :disabled="formLoading">
        <el-row>
          <el-col :span="24">
            <el-form-item label="版块名称" prop="module_name">
              <el-input
                  v-model="form.module_name"
                  maxlength="30"
                  show-word-limit
                  disabled
                  style="width:33%"
              ></el-input>
            </el-form-item>
            <el-form-item label="标题" prop="module_name">
              <el-input
                  v-model="form.title"
                  show-word-limit
                  style="width:33%"
              ></el-input>
            </el-form-item>
            <el-form-item label="版块模板" prop="template_id">
              <el-radio  v-model="form.template_id" :label="1">模板1</el-radio>
              <el-radio  v-model="form.template_id" :label="2">模板2</el-radio>
              <el-radio  v-model="form.template_id" :label="3">模板3</el-radio>
              <el-radio  v-model="form.template_id" :label="4">模板4</el-radio>
              <el-radio  v-model="form.template_id" :label="5">模板5</el-radio>
            </el-form-item>
            
            <el-form-item label="版块效果图">
              <img v-if="form.template_id == 1" src="https://res.defen.hzxinquanzi.com/image/backend/product_module_template/1.png" style="width: 300px;" alt="">
              <img v-if="form.template_id == 2" src="https://res.defen.hzxinquanzi.com/image/backend/product_module_template/2.png" style="width: 300px;" alt="">
              <img v-if="form.template_id == 3" src="https://res.defen.hzxinquanzi.com/image/backend/product_module_template/3.png" style="width: 300px;" alt="">
              <img v-if="form.template_id == 4" src="https://res.defen.hzxinquanzi.com/image/backend/product_module_template/4.png" style="width: 300px;" alt="">
              <img v-if="form.template_id == 5" src="https://res.defen.hzxinquanzi.com/image/backend/product_module_template/5.png" style="width: 300px;" alt="">
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" :loading="onSaveLoading" @click="onSave">创建</el-button>
        </el-form-item>
      </el-form>

    </el-row>
  </div>
</template>
<script>
import {
  createModule
} from "@/api/mall";

export default {
  data: function () {
    return {
      id: '',
      info: {},
      form: {
        module_name: '商品详情列表',
        template_id: 1
      },
      ossAction: "",
      formLoading: false,
      onSaveLoading: false,
    }
  },
  methods: {
    onSave() {
      this.onSaveLoading = true;
      let that = this
      createModule(this.form).then(res => {
        that.onSaveLoading = false;
        if (res.code == 1) {
          that.$message({
            showClose: true,
            duration: 6000,
            message: '保存成功',
            type: 'success'
          });
          that.backPrePage();
        }
      });

    },
    backPrePage() {
      this.$router.go(-1);
    }
  },
}
</script>